import React from 'react';
import { Link } from 'react-router-dom';
import { AAHASearchUrl, Links } from '@/lib/constants';
import styles from './NoSearchResult.module.scss';

interface NoSearchResultsProps {
  query: string;
}

export default function NoSearchResults({ query }: NoSearchResultsProps) {
  return (
    <div className={styles.main}>
      <h4>Sorry, no results found for '{query}'</h4>
      <p>Double check the spelling of the chip ID number and try again.</p>
      <span className={styles.homepageLink}>
        <Link to="/" className="btn-yellow">
          Back to Nano homepage
        </Link>
      </span>
      <a className="btn-outline" href={Links.faq} target="_blank" rel="noopener noreferrer">
        Contact support
      </a>
      <div className={styles.otherRegistriesLink}>
        <a className="btn-outline" href={AAHASearchUrl(query)} target="_blank" rel="noopener noreferrer">
          Check other registries
        </a>
      </div>
    </div>
  );
}
